exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading-spinner-content {\n    text-align: center;\n}\n\n.loading-spinner-content-spinner {\n    font-size: 32px;\n}\n\n.loading-spinner-content-title {\n    margin-top: 24px;\n}\n", ""]);

// exports
